import { Head, Link } from "@inertiajs/react"
import { CheckoutLayout } from "@/components/CheckoutLayout"

export default function Unavailable() {
  return (
    <>
      <Head title="Offer no longer available">
        <meta
          name="description"
          content="This Flywrite offer has expired or sold out. Standard Flywrite plans are still available."
        />
        <meta property="og:title" content="Offer no longer available" />
        <meta
          property="og:description"
          content="This Flywrite offer has expired or sold out. Standard Flywrite plans are still available."
        />
      </Head>
      <CheckoutLayout
        main={
          <div className="text-center">
            <h1>This offer is no longer available</h1>
            <p className="mt-3 text-sm text-ink-muted">
              It may have expired or sold out. Flywrite's standard plans are still available —
              annual seats with a 14-day money-back guarantee.
            </p>
            <p className="mt-6">
              <Link href="/buy" className="btn btn-primary">
                See Flywrite pricing
              </Link>
            </p>
          </div>
        }
      />
    </>
  )
}
